import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IAppConfig } from '../app/model/app-config.model';
import { GOODWILL_CONSTANT } from './utils/constant';


@Injectable()
export class AppConfig {
    public apiUrl: string;
    public apiPath: string;
    public mpsaFlag: string;
    constructor(private http: HttpClient) {}

    load(url:string):Promise<any> {
        const promise = this.http.get(url)
        .toPromise()
        .then(data => {
          Object.assign(this, data);
          return data;
        });

      return promise;
    }

  
}